import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";
// 春城卡
import springCard from "./springCard";

Vue.use(Vuex);
const state = {
  list: []
};

const mutations = {
  list(state, data) {
    state.list = data;
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  modules: {
    springCard
  },
  plugins: [persistedState({ storage: window.sessionStorage })]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js